import { render } from "./agencySlide4.vue?vue&type=template&id=9cb5a0fc"
import script from "./agencySlide4.vue?vue&type=script&lang=js"
export * from "./agencySlide4.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__